import React, { useCallback, useEffect, useState } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import '../../Styles/bottomSheet.css';
import {
  dismissPhotoSourceSheet,
  registerPhotoSourceSheetHost,
  resolvePhotoSourceSheet,
} from '../../Services/PhotoSource/photoSourceSheet';
import { useBackStack } from '../../Hooks/back/useBackStack';

function OptionRow({ icon, label, description, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center gap-4 rounded-2xl px-4 py-4 text-left transition-colors active:bg-slate-50"
    >
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-slate-100 text-slate-600">
        <span className="material-symbols-outlined text-[26px]">{icon}</span>
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-base font-bold text-slate-900">{label}</span>
        {description && (
          <span className="mt-0.5 block text-sm text-slate-500">{description}</span>
        )}
      </span>
    </button>
  );
}

export default function PhotoSourceBottomSheetHost() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    registerPhotoSourceSheetHost(setOpen);
  }, []);

  const handleDismiss = useCallback(() => {
    dismissPhotoSourceSheet();
  }, []);

  useBackStack({
    type: 'sheet',
    enabled: open,
    onBack: handleDismiss,
  });

  return (
    <BottomSheet
      open={open}
      onDismiss={handleDismiss}
      snapPoints={({ minHeight }) => [minHeight]}
      defaultSnap={({ snapPoints }) => snapPoints[0]}
      initialFocusRef={false}
    >
      <div className="bg-white pb-[env(safe-area-inset-bottom,0px)]">
        <div className="border-b border-slate-100 px-5 py-4">
          <h2 className="text-lg font-bold text-slate-900">사진 추가</h2>
          <p className="mt-1 text-sm text-slate-500">
            갤러리에서 선택하거나 카메라로 촬영하세요
          </p>
        </div>

        <div className="px-2 pt-2 pb-0">
          <OptionRow
            icon="photo_library"
            label="갤러리에서 선택"
            onClick={() => resolvePhotoSourceSheet('gallery')}
          />
          <OptionRow
            icon="photo_camera"
            label="카메라로 촬영"
            onClick={() => resolvePhotoSourceSheet('camera')}
          />
        </div>
      </div>
    </BottomSheet>
  );
}
 